import React from 'react';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';

const ScoreDistributionChart = ({ distribution = [] }) => {
  if (!Array.isArray(distribution) || distribution.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No score data available for the selected filters.
      </Typography>
    );
  }

  return (
    <Stack spacing={1.5}>
      {distribution.map((bucket) => (
        <Box key={bucket.bucket}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" fontWeight={600}>{bucket.bucket}</Typography>
            <Typography variant="caption" color="text.secondary">
              {bucket.count} attempts · {bucket.percentage}%
            </Typography>
          </Stack>
          <LinearProgress
            variant="determinate"
            value={Math.min(bucket.percentage || 0, 100)}
            sx={{ height: 8, borderRadius: 999, mt: 0.5 }}
          />
        </Box>
      ))}
    </Stack>
  );
};

export default ScoreDistributionChart;
